import { useState } from "react";

interface ImageWithFallbackProps {
    src: string;
    alt: string;
    className?: string;
  }
  
export default function ImageWithFallback({ src, alt, className }: ImageWithFallbackProps) {
    const [imageLoaded, setImageLoaded] = useState(true);
  
    const onError = () => {
      setImageLoaded(false);
    };
  
    return imageLoaded ? (
      <img src={src} alt={alt} className={className} onError={onError} />
    ) : (
      <div className={`placeholder-image ${className}`} aria-label={alt}></div>
    );
  }